/**
 * Posts IMA/VAST lifecycle events to BE measurement ingest.
 * No-ops when measurement disabled or payload incomplete.
 */

import { trackVideoAdEvent, getAdSessionId } from "../../components/Advertising/advertisingApi";
import { VideoAdLifecycle } from "./VideoAdLifecycle";

var LIFECYCLE_TO_EVENT = {};
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_IMPRESSION] = "impression";
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_START] = "start";
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_FIRST_QUARTILE] = "first_quartile";
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_MIDPOINT] = "midpoint";
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_THIRD_QUARTILE] = "third_quartile";
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_COMPLETE] = "complete";
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_SKIP] = "skip";
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_CLICK] = "click";
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_ERROR] = "error";
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_NO_FILL] = "no_fill";
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_BREAK_START] = "break_start";
LIFECYCLE_TO_EVENT[VideoAdLifecycle.AD_BREAK_END] = "break_end";

/**
 * @param {object} [options]
 * @param {boolean} [options.enabled]
 * @param {string} [options.placementKey]
 * @param {number|null} [options.campaignId]
 * @param {number|null} [options.creativeId]
 * @param {string} [options.breakId]
 * @param {string} [options.breakKind]
 * @param {string} [options.contentId]
 * @returns {{ handle: function(string, object=): void, setContext: function(object): void }}
 */
export function createVideoAdMeasurement(options) {
  options = options || {};
  var ctx = {
    enabled: options.enabled === true,
    placementKey: options.placementKey || "player_preroll",
    campaignId: options.campaignId || null,
    creativeId: options.creativeId || null,
    breakId: options.breakId || null,
    breakKind: options.breakKind || null,
    contentId: options.contentId || null,
  };

  return {
    setContext: function (next) {
      Object.assign(ctx, next || {});
    },
    handle: function (lifecycleName, payload) {
      if (!ctx.enabled) return;
      var eventType = LIFECYCLE_TO_EVENT[lifecycleName];
      if (!eventType) return;
      // Deterministic client idempotency key — same break/event/retry must not double-count.
      // Include session so a later playback of the same content can still measure.
      var sessionPart = "";
      try {
        sessionPart = getAdSessionId() || "";
      } catch (e) {
        sessionPart = "";
      }
      var clientEventId = [
        "ve",
        eventType,
        ctx.placementKey || "",
        ctx.breakId || "",
        String(ctx.campaignId || "0"),
        String(ctx.creativeId || "0"),
        ctx.contentId || "",
        sessionPart,
      ]
        .join("_")
        .replace(/[^a-zA-Z0-9_\-.]/g, "")
        .slice(0, 64);
      trackVideoAdEvent({
        event_type: eventType,
        placement_key: ctx.placementKey,
        campaign_id: ctx.campaignId,
        creative_id: ctx.creativeId,
        break_id: ctx.breakId,
        break_kind: ctx.breakKind,
        content_id: ctx.contentId,
        client_event_id: clientEventId,
        error_code:
          payload && (payload.code || payload.reason)
            ? String(payload.code || payload.reason).slice(0, 64)
            : null,
        meta: payload || null,
      });
    },
  };
}

export default createVideoAdMeasurement;
